import { t } from '@lingui/macro';
import moment from 'moment';

/**
 *  utitlity functions
 */
export function handleDefaults(defaultObj, dynamicObj) {
  for (const key in dynamicObj) {
    defaultObj[key] = dynamicObj[key];
  }
  return defaultObj;
}

// 3P host apps get the configuration from the global window object injected by host app.
// On developers system when running the webpack server we do not have access to pppAppConfig object
// To facilitate the local development we have a fallback.
export async function getConfiguration(name) {
  // eslint-disable-next-line no-underscore-dangle
  return window._env_[name];
}

export function log() {}

// Until we get Nullish coalescing operator
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Nullish_coalescing_operator
export function isDefined(x) {
  return x !== undefined && x !== null;
}

export function getContextCoords(
  position,
  modalWidth,
  modalHeight = 260,
  leftAlign = false
) {
  const leftOffset = position.left || position.x || position.clientX;
  const innerOffsetRight =
    window.innerWidth - (position.right || position.clientX);
  const innerOffsetLeft = leftOffset - modalWidth;
  const coords = {};
  const windowHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;

  if (leftAlign) {
    const mid = (position.top + position.bottom) / 2;
    coords.posX = position.right + 12;
    coords.posArrow = position.right;
    coords.posArrowY = mid - 8;
    coords.posY =
      window.innerHeight - position.bottom < 150
        ? position.bottom + 5
        : position.bottom - 75;
    return coords;
  }

  coords.posY = (position.bottom || position.clientY) + 5;
  const reverseArrow = coords.posY + modalHeight > windowHeight;

  coords.posArrow = leftOffset + (position.width || 2) / 2;

  if (reverseArrow) {
    const heightOffset = modalHeight + 45;
    coords.posY -= heightOffset;
  }
  if (innerOffsetRight > modalWidth && innerOffsetLeft > modalWidth) {
    coords.posX = coords.posArrow - modalWidth / 2; // center aligned
  } else if (innerOffsetLeft < modalWidth && innerOffsetRight > modalWidth) {
    coords.posX = coords.posArrow - 15; // left aligned
  } else {
    coords.posX = coords.posArrow - modalWidth + 15; // right aligned
  }
  coords.reverseArrow = reverseArrow;
  return coords;
}

/**
 *  constants
 */

export const studentStatus = {
  ASSIGNED: 0,
  INPROGRESS: 1,
  PAST_DUE_DATE: 2,
  UNATTEMPTED: 3
};

export const assignmentType = {
  RESTRICTED: 0,
  NON_RESTRICTED: 1
};

export const MAX_STUDENT_NAME_LENGTH = 22;
export const MAX_CLASSNAME_LENGTH = 20;
export const MAX_ITEMS_TO_DISPLAY = 14;
export const MAX_GROUP_NAME_LENGTH = 20;
export const DEFAULT_POLL_DELAY = 10000;
export const LOCALE_DEFAULT = 'en-AU';

/* helper method to attach suffix to the numbers */
export const attachSuffix = (val, i18n) => {
  const j = val % 10;
  const k = val % 100;

  if (j === 1 && k !== 11) {
    return `${val}${i18n._(t('utils.suffix.st')`st`)}`;
  }
  if (j === 2 && k !== 12) {
    return `${val}${i18n._(t('utils.suffix.nd')`nd`)}`;
  }
  if (j === 3 && k !== 13) {
    return `${val}${i18n._(t('utils.suffix.rd')`rd`)}`;
  }
  return `${val}${i18n._(t('utils.suffix.th')`th`)}`;
};

/* constants used for doughnut component */
export const CLASSROOM = 0;
export const GROUP = 1;
export const STUDENT = 2;
export const MOUSE_STATE_ENTER = 'MOUSE_STATE_ENTER';
export const MOUSE_STATE_LEAVE = 'MOUSE_STATE_LEAVE';
export const MOUSE_STATE_CLICK = 'MOUSE_STATE_CLICK';

export const xPosCommon = 80;
export const yPosCommon = 80;
export const radiusCommon = 70;
export const colorCommon = '#e8f3f3';
export const widthCommon = 12;
export const fillCommon = 'transparent';
export const dashOffsetCommon = 0;
export const lineCapCommon = 'round';

export const classColor = '#c5e0e1';
export const groupColor = '#c6d4e1';
export const studentColor = '#088bd3';
export const doughnutWidth = widthCommon;
export const doughnutGap = 6;

export function getTruncatedName(name) {
  return name.length > MAX_STUDENT_NAME_LENGTH
    ? `${name.substr(0, MAX_STUDENT_NAME_LENGTH)}...`
    : name;
}

export function getHyphenDateFormat(date) {
  return date.replace(/\//g, '-');
}

// dueDatePreference is the saved [date, time] pair; undefined means no due date.
export function getDueDateISOString(dueDatePreference) {
  if (!dueDatePreference) return undefined;
  return moment(
    `${getHyphenDateFormat(dueDatePreference[0])} ${getHyphenDateFormat(
      dueDatePreference[1]
    )}`
  ).toISOString();
}



// WEBPACK FOOTER //
// ./helpers/utils.js